module.exports = __webpack_public_path__ + "img/sec5_1_.7cbf73be.png";